import { render, staticRenderFns } from "./RBanner.vue?vue&type=template&id=edadb5ec&"
import script from "./RBanner.vue?vue&type=script&lang=js&"
export * from "./RBanner.vue?vue&type=script&lang=js&"
import style0 from "./RBanner.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports